import type { PropsWithChildren, ReactNode } from "react";
import type { TenantInfo } from "../api/types";
import { TenantLogo } from "./TenantLogo";

interface AuthShellProps extends PropsWithChildren {
  tenant: TenantInfo;
  title: string;
  description?: string;
  footer?: ReactNode;
}

export function AuthShell({
  tenant,
  title,
  description,
  children,
  footer,
}: AuthShellProps) {
  return (
    <main
      className="portal-background flex min-h-screen items-center justify-center px-5 py-10"
      style={{ "--tenant-background": tenant.nmportalbackgroundcolor } as never}
    >
      <section className="w-full max-w-md rounded-2xl border border-slate-200/80 bg-white p-6 shadow-xl shadow-slate-900/5 sm:p-8">
        <div className="mb-7 text-center">
          <TenantLogo tenant={tenant} />
          <p className="text-sm font-medium text-teal-700">{tenant.nmtenant}</p>
          <h1 className="mt-1 text-2xl font-semibold tracking-tight text-slate-950">
            {title}
          </h1>
          {description && (
            <p className="mt-2 text-sm leading-6 text-slate-600">
              {description}
            </p>
          )}
        </div>
        {children}
        {footer && (
          <div className="mt-6 border-t border-slate-100 pt-5 text-center text-sm text-slate-600">
            {footer}
          </div>
        )}
      </section>
    </main>
  );
}
